// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progress-ring{position:absolute;left:-20px;top:-4px;z-index:-1}.progress-ring__circle{transition:stroke-dashoffset .35s;transform:rotate(-90deg);transform-origin:50% 50%}.audio-player{background-image:url(/play.svg);height:76px;width:76px}.audio-player--pause{background-image:url(/pause.svg)}", ""]);
// Exports
module.exports = exports;
